// Desktop keyboard legend, drawn statically on `#s06` desktop next to the
// heading: "Keyboard: J/K move · C categorize · B business · U undo".
export function InboxKeyboardLegend() {
  return (
    <span className="text-xs text-muted-foreground" data-testid="inbox-keyboard-legend">
      Keyboard: J/K move · C categorize · B business · U undo
    </span>
  );
}

export default InboxKeyboardLegend;
